import { RootAppState } from 'store/configureStore'

export const projectIsNestingSelector = (state: RootAppState) => {
  return state.project?.projectOperations?.isNesting
}
